import {combineReducers} from 'redux';
import education_Reducer from './education_Reducer';
import appReducer from './appSlice';
import {depotLogisticApi} from './DepotSlice/depotLogisticApi';
import {depotOrdersApi} from './DepotSlice/depotOrdersApi';
import {configureStore} from '@reduxjs/toolkit';
import {depotReportApi} from './DepotSlice/depotReportApi';
import {depotCashierApi} from './DepotSlice/depotCashierApi';
import {userClientsApi} from './userClientsApi';
import {activitiesApi} from './activitiesApi';
import {userOrdersApi} from './userOrdersApi';
import {userBillingApi} from './userBillingApi';
import {deliveryApi} from './deliveryApi';
import {userApi} from './userApi';
import {myDynamicApi} from './myDynamicApi';
import userSlice from './userSlice';
import {newsApi} from './newsApi';

const rootReducer = combineReducers({
	userData: userSlice, // Заменяем старый userReducer на новый userSlice
	educationData: education_Reducer,
	appData: appReducer,
	[depotLogisticApi.reducerPath]: depotLogisticApi.reducer,
	[depotOrdersApi.reducerPath]: depotOrdersApi.reducer,
	[depotReportApi.reducerPath]: depotReportApi.reducer,
	[depotCashierApi.reducerPath]: depotCashierApi.reducer,
	[userClientsApi.reducerPath]: userClientsApi.reducer,
	[activitiesApi.reducerPath]: activitiesApi.reducer,
	[userOrdersApi.reducerPath]: userOrdersApi.reducer,
	[userBillingApi.reducerPath]: userBillingApi.reducer,
	[deliveryApi.reducerPath]: deliveryApi.reducer,
	[myDynamicApi.reducerPath]: myDynamicApi.reducer,
	[userApi.reducerPath]: userApi.reducer,
	[newsApi.reducerPath]: newsApi.reducer,
});

export type RootState = ReturnType<typeof rootReducer>;
export const store = configureStore({
	reducer: rootReducer,
	middleware: (getDefaultMiddleware) =>
		getDefaultMiddleware()
			.concat(depotLogisticApi.middleware)
			.concat(depotOrdersApi.middleware)
			.concat(depotReportApi.middleware)
			.concat(depotCashierApi.middleware)
			.concat(userClientsApi.middleware)
			.concat(userOrdersApi.middleware)
			.concat(userBillingApi.middleware)
			.concat(deliveryApi.middleware)
			.concat(activitiesApi.middleware)
			.concat(myDynamicApi.middleware)
			.concat(userApi.middleware)
			.concat(newsApi.middleware),
	devTools: true,
});
export type AppDispatch = typeof store.dispatch;
export default store;
